/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useEffect, useState } from 'react';
import { useStore } from '../../../store';
import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgAvater8 from '../../../../../assets/tips-person.png';
import Conversationright from '../../../../../assets/conversation-right.png';
import './animation046.less';
import { Tabs } from 'antd';
const { TabPane } = Tabs;
interface IAnimation046Item {
  content: string;
  img?: string;
}
interface IAnimation046Props {
  items: {
    tip?: string;
    pic?: string;
    title?: string;
    content?: string;
    items: IAnimation046Item[];
  }[];
  onCompleted?: () => void;
  className: string;
}

const Animation046: React.FunctionComponent<IAnimation046Props> = ({
  items,
  onCompleted,
  className,
}) => {
  const { language } = useStore();
  const getImg = (img: string) =>
    require(`../../../../../assets/${img}`).default;
  const settings =
    language === 'en'
      ? {
          viewlabel: 'Click here',
        }
      : language === 'sc'
      ? {
          viewlabel: '点击查看',
        }
      : {
          viewlabel: '點擊查看',
        };
  const [tabValue, setTabValue] = useState('1');
  const [completed, setCompleted] = useState(items.map((itm) => 0));
  const [lastClick, setLastClick] = useState(0);

  const play = (index: number) => {
    setCompleted(
      completed.map((itm: any, idx: number) => (idx === index ? itm + 1 : itm))
    );
    setLastClick(lastClick + 1 < 7 ? lastClick + 1 : lastClick);
  };

  const [show, setShow] = useState(true);

  useEffect(() => {
    if (!completed.some((itm, idx) => itm + 1 < items[idx].items.length)) {
      onCompleted && onCompleted();
    }
  }, [completed]);

  useEffect(() => {
    console.log(lastClick);
    if (tabValue === '1') {
      if (lastClick < 6) {
        setShow(false);
      } else {
        setShow(true);
      }
    } else {
      setShow(false);
    }
  }, [tabValue, lastClick]);
  return (
    <div className={`animation046 ${className || ''}`}>
      <img className="click-point-tab" hidden={!show} src={ImgPoint} alt="" />
      <Tabs
        type="card"
        className={`animation046-topic-tab tab${tabValue}`}
        onChange={(activeKey) => setTabValue(activeKey)}
      >
        {items.map((itm: any, index: number) => (
          <TabPane tab={itm.title} key={`${index + 1}`}>
            {itm.tip && (
              <div className="talk">
                <img className="pic1" src={ImgAvater8} alt="" />
                <img className="pic2" src={Conversationright} alt="" />
                <div className="talk-content">{itm.tip}</div>
              </div>
            )}
            <div className={`animation046-card-tab tab${index + 1}`}>
              <p className="content">{itm.content}</p>
              <div className="animation046-card-list">
                {itm.items.map((card: IAnimation046Item, idx: number) => (
                  <div
                    key={idx}
                    className="animation046-card-item"
                    style={{ width: `${(1 / itm.items.length) * 100}%` }}
                  >
                    <div
                      className="text"
                      dangerouslySetInnerHTML={{ __html: card.content }}
                    />
                    {card.img && (
                      <img className="img" src={getImg(card.img)} alt="" />
                    )}
                    {completed[index] < idx && (
                      <div className="clickable" onClick={() => play(index)}>
                        <div className="clickable-label">
                          {settings.viewlabel}
                        </div>
                        {completed[index] === idx - 1 && (
                          <img className="click-point" src={ImgPoint} alt="" />
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default Animation046;
